resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function FormatPercent () {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [AnimateNumeric];
  this.declaredClass = null;

  this.fraction = true;
  this.fractionSpaces = 2;
  this.hasSymbolCharacter = true;
  this.hasSmallSymbolCharacter = true;
  this.symbolCharacter = '%';

  // Classes
  this._classes = {
    class: 'format-percent',
    integer: 'format-percent__integer',
    fraction: 'format-percent__fraction',
    symbol: 'format-percent__symbol'
  };

  // create elements
  this.$integer = $('<span></span>');
  this.$fraction = $('<sup></sup>');
  this.$symbol = $('<span>' + this.symbolCharacter + '</span>');

  // add classes
  this.$integer.addClass(this._classes.integer);
  this.$fraction.addClass(this._classes.fraction);
  this.$symbol.addClass(this._classes.symbol);

  this.init = function () {
    // Setup the input
    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);

    // setup masking value
    this.maskCallback = function (value) {
      var $markup = $('<div></div>');

      // format value
      if (isNaN(value)) value = 0;
      value = parseFloat(value).toFixed(this.fractionSpaces).toString();
      value = value.split('.');

      // fill html with data
      this.$integer.text(value[0]);
      this.$fraction.text('.' + value[1]);

      // create return string and return it

      $markup.append(this.$integer);
      if (this.fraction) $markup.append(this.$fraction);
      if (this.hasSymbolCharacter) {
        if (this.hasSmallSymbolCharacter) {
          this.$fraction.append(this.$symbol);
        } else {
          $markup.append(this.$symbol);
        }
      }

      return $markup.html();
    };

    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.destroy = function () {
    this._super();
  };
}
